class HelperAnalyticsEvent {
    static defaultInfo = () => {
        return {
          pageInfo: window.adobeDataLayer?.[0]?._avnet?.pageInfo || {},
          userInfo: window.adobeDataLayer?.[0]?._avnet?.userInfo || {}
        }
      }

      static typeHeadSearchEvent(searchParam,tabType,linkName,url) {
        const searchEvent = {
          event: "typeheadSearch",
          _avnet: {
            internalSearchInfo: {
              searchType: "Internal",
              searchTerm: searchParam,
              searchTab: tabType,
            },
            linkInfo: {
              linkName: linkName,
              linkUrl: url,
              linkLocation: "typeheadSearchResults",
              linkType: "link",
              linkComponent: "typeheadPopup",
            },
            ...this.defaultInfo()
          },
        };
        window.adobeDataLayer.push(searchEvent);
      }

  static bomSwitchToFarnell(dataPoints) {
    const { selectedSite, bomInfo } = dataPoints;
    const bomSwitchToFarnellEvent = {
      "event": "siteSwitchInBom",
      "_avnet": {
        "siteSelected": selectedSite,
        "bomInfo": bomInfo,
        ...this.defaultInfo()
      }
    }
    window?.adobeDataLayer?.push(bomSwitchToFarnellEvent);
  }
}

export default HelperAnalyticsEvent;